import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import {useTranslation} from 'react-i18next';
import {AgyleLogoIcon} from '../../../components/icons/icons';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        flexWrap: 'nowrap',
        color: '#000',
        backgroundColor: '#fff',
        fontWeight: 600,
        gap: 10,
        padding: 20,
    },
    opps: {
        fontSize: 48,
    },
    title: {
        fontSize: 24,
    },
    message: {
        fontSize: 14,
    },
}));

const FormErrorPage = () => {
    const classes = useStyles();
    const {t} = useTranslation();

    return (
        <div className={classes.root}>
            <AgyleLogoIcon style={{fontSize: 124}}/>

            <div className={classes.opps}>
                Oops!
            </div>

            <div className={classes.title}>
                {t('errorPage.title')}
            </div>

            <div className={classes.message}>
                <span>
                    {t('errorPage.messageFrom')}
                </span>
            </div>
        </div>
    );
};

export default FormErrorPage;